import { render, staticRenderFns } from "./StackCarousel.vue?vue&type=template&id=be27389e&scoped=true&"
import script from "./StackCarousel.vue?vue&type=script&lang=js&"
export * from "./StackCarousel.vue?vue&type=script&lang=js&"
import style0 from "./StackCarousel.vue?vue&type=style&index=0&id=be27389e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be27389e",
  null
  
)

export default component.exports